// extracted by mini-css-extract-plugin
export default {"lang_list":"lang-list_lang_list__LIR7l","active":"lang-list_active__foaR+","flag":"lang-list_flag__ubB37","language":"lang-list_language__MaoYM"};